import React from 'react';

// @ts-ignore
import * as styles from './Loading.module.scss';

export function Loading() {
  return (
    <div className={styles.LoadingWrapper}>
      <div className={styles.LoadingRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
